<template>
  <div id="trumbowyg-editor"></div>
</template>

<style lang="scss">
  @import '~trumbowyg/dist/ui/sass/trumbowyg.scss';
</style>

<script>
  import $ from 'jquery';
  import 'trumbowyg';
  import '@/translations/trumbowyg';
  import 'trumbowyg/dist/plugins/upload/trumbowyg.upload.min';
  import 'trumbowyg/dist/plugins/noembed/trumbowyg.noembed.min';

  const language = localStorage.getItem('lang');

  const btns = [
    ['viewHTML'],
    ['undo', 'redo'],
    ['formatting'],
    ['strong', 'em', 'del'],
    ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
    ['unorderedList', 'orderedList'],
    ['superscript', 'subscript'],
    ['link'],
    ['insertImage'],
    ['horizontalRule'],
    ['removeformat'],
    ['fullscreen'],
  ];

  const plugins = {
    // Add imagur parameters to upload plugin
    upload: {
      serverPath: 'https://api.imgur.com/3/image',
      fileFieldName: 'image',
      headers: {
        Authorization: 'Client-ID eb7bc3b4312bd39',
      },
      urlPropertyName: 'data.link',
    },
  };

  export default {
    mounted() {
      $.trumbowyg.svgPath = this.svgPath;
      $('#trumbowyg-editor').trumbowyg(
        {
          lang: language,
          btnsDef: {
            // Customizables dropdowns
            insertImage: {
              dropdown: ['insertImage', 'upload', 'noembed'],
              ico: 'insertImage',
            },
          },
          btns,
          plugins,
          disabled: this.disabled,
        },
      ).on('tbwblur', this.onBlur);
      $('#trumbowyg-editor').html(this.content);
    },
    props: {
      content: {
        type: String,
        default: '',
      },
      svgPath: {
        type: String,
        default: '/static/trumbowyg-icons.svg',
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      onBlur() {
        const content = $('#trumbowyg-editor').trumbowyg('html');
        this.$emit('tbwblur', content);
      },
      setContent(content) {
        $('#trumbowyg-editor').html(content);
      },
    },
  };
</script>

<style>
  .trumbowyg-box .trumbowyg-button-pane svg {
    width: 18px;
    fill: #233d53;
  }

  .trumbowyg-box .trumbowyg-button-pane .trumbowyg-button-group button:hover {
    background: #eee;
  }
  .trumbowyg-button-pane {
    background: none !important;
  }
  .trumbowyg-editor {
    height: 100% !important;
    max-height: 900px;
  }
  .trumbowyg-box.trumbowyg-editor-visible.trumbowyg-en.trumbowyg {
    height: auto;
  }
</style>



// WEBPACK FOOTER //
// Trumbowyg.vue?0e6d709c